import { render } from "./ExpandedViewItem.vue?vue&type=template&id=a9b45af4"
import script from "./ExpandedViewItem.vue?vue&type=script&lang=js"
export * from "./ExpandedViewItem.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__